<template>
  <div v-if="isVisible">
      <div  v-for="tag in field.question_option_tag" :tabIndex="question.id"  :key="tag.id" class="custom-control custom-checkbox checkbox-xl">
          <input class="custom-control-input"  :ref="field.form_key + tag.id" type="checkbox" :name="field.form_key"
                  :id="field.form_key + tag.id" v-bind:value="tag.value" v-model="uAnswer" @focus="$emit('questionSelected', question.order)">
          <label class="custom-control-label" :for="field.form_key + tag.id">
              {{ tag.value}}
          </label>
      </div>
  </div>
</template>

<script>

import elementMixins from '../mixins/elements'

export default {
  name: 'LUSelectMultiple',
  props: [
    'question',
    'field',
    'answers'
  ],
  mixins: [elementMixins],


  watch: {
    uAnswer: function(){
      this.answer = this.uAnswer

    },
  },
created () {

      if(this.answer){
        this.uAnswer = this.answer
      }
  },
  /**
   * Because this is a multiple select, the binding to the answers causes a Vue Warning.
   * This is a workaround
   * @see https://stackoverflow.com/questions/43398029/vue-js-multiple-select-error
   */
  data: function () {
    return {
      uAnswer: []
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/elements/SelectMultiple.vue